import React from 'react'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useGlobaleContext} from '../../../contexts/globale'
import {
    PayPalIcon,
    ApplePayIcon,
    VisaNewIcon,
    MastercardNewIcon,
    AmexNewIcon,
    DiscoverNewIcon,
    AfterpayIcon,
    AffirmIcon,
    CashappIcon
} from '../../../components/icons'

const PAYMENT_METHODS = [
    {id: 'paypal', label: 'PayPal', Icon: PayPalIcon},
    {id: 'apple-pay', label: 'Apple Pay', Icon: ApplePayIcon},
    {id: 'visa', label: 'Visa', Icon: VisaNewIcon},
    {id: 'mastercard', label: 'Mastercard', Icon: MastercardNewIcon},
    {id: 'amex', label: 'American Express', Icon: AmexNewIcon},
    {id: 'discover', label: 'Discover', Icon: DiscoverNewIcon},
    {id: 'afterpay', label: 'Afterpay', Icon: AfterpayIcon},
    {id: 'affirm', label: 'Affirm', Icon: AffirmIcon},
    {id: 'cashapp', label: 'Cash App', Icon: CashappIcon}
]

const AcceptedPaymentMethods = () => {
    const {countryISO} = useGlobaleContext()
    const cartStyles = useMultiStyleConfig('CartStyles')

    if (countryISO !== 'US') return null

    return (
        <Box
            id="cart-accepted-payment-methods"
            data-testid="accepted-payment-methods"
            {...cartStyles.acceptedPaymentMethods}
        >
            <Text {...cartStyles.acceptedPaymentMethodsLabel}>We accept</Text>
            <Flex {...cartStyles.acceptedPaymentMethodsIconsContainer}>
                {PAYMENT_METHODS.map(({id, label, Icon}) => (
                    <Icon
                        key={id}
                        aria-label={label}
                        data-payment-method={id}
                        {...cartStyles.acceptedPaymentMethodsIcon}
                    />
                ))}
            </Flex>
        </Box>
    )
}

export default AcceptedPaymentMethods
